var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from "react";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/folio.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/input/InputComponent.scss";
import "@frameworks/shared-library/stylesheets/components/NCD/transaction.scss";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
var Select = function (_a) {
    var _b;
    var _c = _a.data, data = _c === void 0 ? [] : _c, value = _a.value, onSelect = _a.onSelect, label = _a.label, onFetchDefaultValue = _a.onFetchDefaultValue, isModifyCta = _a.isModifyCta, openLocal = _a.openLocal, setOpenLocal = _a.setOpenLocal;
    var _d = __read(useState(false), 2), open = _d[0], setOpen = _d[1];
    var _e = __read(useState(value || (data.length > 0 ? data[0].value : "")), 2), selectedValue = _e[0], setSelectedValue = _e[1]; // Default value
    var searchRef = useRef(null);
    useEffect(function () {
        if (onFetchDefaultValue && data.length > 0) {
            var defaultItem = data[0];
            onFetchDefaultValue(defaultItem);
            setSelectedValue(defaultItem.value);
        }
    }, [data]);
    var handleSelect = function (item) {
        setSelectedValue(item.value);
        onSelect(item);
        setOpen(false);
        if (openLocal) {
            setOpenLocal(false);
        }
    };
    useEffect(function () {
        function handleClickOutside(event) {
            if (searchRef.current &&
                !searchRef.current.contains(event.target)) {
                setOpen(false);
                if (openLocal) {
                    setOpenLocal(false);
                }
            }
        }
        document.addEventListener("click", handleClickOutside);
        return function () {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    return (React.createElement("div", { ref: searchRef, className: "ai-container position-relative otc-transaction-flow" },
        React.createElement("label", { className: "ai-label DMSanN_14_400 ms-1" }, label),
        React.createElement("div", { className: "folio-selector ".concat(isModifyCta && "bg_monochromeGrey") },
            React.createElement("div", { className: "folio-selector__header ".concat(open || openLocal ? "folio-selector__header_open" : ""), onClick: function () {
                    if (!isModifyCta) {
                        setOpen(!open);
                        setOpenLocal(!openLocal);
                    }
                } },
                React.createElement("div", { className: "folio-selector__selected width-91" },
                    React.createElement("p", { className: "txt-midnight-blue DMSanN_14_400 text-truncate w-100" }, selectedValue
                        ? ((_b = data.find(function (item) { return item.value === selectedValue; })) === null || _b === void 0 ? void 0 : _b.label) ||
                            "Select DP Id"
                        : "Select DP Id")),
                React.createElement("div", { className: "folio-selector__toggle" }, open || openLocal ? (React.createElement("span", { className: "edel-icon-arrow-up d-flex justify-content-center align-items-center size-16" })) : (React.createElement("span", { className: "edel-icon-arrow-down d-flex justify-content-center align-items-center size-16" })))),
            (open || openLocal) && (React.createElement("div", { className: "folio-selector__list shadow-custom position-absolute", style: { top: "80px" } }, data.length > 0 ? (data.map(function (item, index) { return (React.createElement("label", { key: item.value, className: "folio-selector__item ".concat(item.value === selectedValue ? "active" : ""), onClick: function () { return handleSelect(item); } },
                React.createElement("div", null,
                    React.createElement("div", { className: "txt-grey-shade1 DMSanN_14_400 ".concat(item.value === selectedValue ? "active" : "") }, item.label)))); })) : (React.createElement(Errormsg, { customMsg: React.createElement("div", { className: "d-flex flex-column align-items-center text-center height-100" },
                    React.createElement("i", { style: { width: "120px", height: "auto" }, className: " edel-icon-error-msg-icon" }),
                    React.createElement("h2", { className: "DMSansNormal_12_400 txt_midnight-blue-shade3" }, "No data available at this moment.")), showIcon: false })))))));
};
export default Select;
